import { layoutConfigurations } from "./WidgetConstants";

export const FILL_WIDGET_MIN_WIDTH: number =
  layoutConfigurations.MOBILE.maxWidth;
export const ICON_BUTTON_MIN_WIDTH = 50;
export const BUTTON_MIN_WIDTH = 120;
